import { useTranslation } from 'react-i18next'

import { NewWindowSmallIcon } from '@pleio/icons/new-window-small'

import Text from 'js/components/Text/Text'

type Props = {
    source: string
}

const EventLink = ({ source }: Props) => {
    const { t } = useTranslation()

    return (
        <Text>
            <a href={source} target="_blank" rel="noopener noreferrer">
                {t('entity-event.external-link')}
                <NewWindowSmallIcon
                    style={{ display: 'inline-block', marginLeft: '6px' }}
                />
            </a>
        </Text>
    )
}

export default EventLink
